import * as types from "./mutation-types";

export default {
  [types.ADD_ITEM](state, item) {
    //alert('ddd1');
    state.itemstest.push(item);
    //alert(state.itemstest.length);
  }
};
